<main class="container news-media">
  <nav class="news-media__tabs" [attr.aria-label]="'NEWS-MEDIA_TABS-LABEL' | translate">
    <a
      class="news-media__tab"
      *ngFor="let tab of tabs; trackBy: trackByRoute"
      [routerLink]="['/news-media', tab.route]"
      routerLinkActive="news-media__tab--active"
    >
      <img class="news-media__tab-icon" [src]="tab.icon" alt="" aria-hidden="true" />
      <span>{{ tab.labelKey | translate }}</span>
    </a>
  </nav>

  <div class="news-media__panel">
    <router-outlet></router-outlet>
  </div>
</main>
